module.exports = __webpack_public_path__ + "static/21b-08a8a04ba325f84022d2aa040a1d03d1.jpg";